let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3c6qD")).then(() => parcelRequire('ieNZ0'));